/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  EstimatedActivity,
  EstimatedActivity$inboundSchema,
  EstimatedActivity$Outbound,
  EstimatedActivity$outboundSchema,
} from "./estimatedactivity.js";

export type MoneyTransferPushToCard = {
  estimatedActivity?: EstimatedActivity | undefined;
};

/** @internal */
export const MoneyTransferPushToCard$inboundSchema: z.ZodType<
  MoneyTransferPushToCard,
  z.ZodTypeDef,
  unknown
> = z.object({
  estimatedActivity: EstimatedActivity$inboundSchema.optional(),
});
/** @internal */
export type MoneyTransferPushToCard$Outbound = {
  estimatedActivity?: EstimatedActivity$Outbound | undefined;
};

/** @internal */
export const MoneyTransferPushToCard$outboundSchema: z.ZodType<
  MoneyTransferPushToCard$Outbound,
  z.ZodTypeDef,
  MoneyTransferPushToCard
> = z.object({
  estimatedActivity: EstimatedActivity$outboundSchema.optional(),
});

export function moneyTransferPushToCardToJSON(
  moneyTransferPushToCard: MoneyTransferPushToCard,
): string {
  return JSON.stringify(
    MoneyTransferPushToCard$outboundSchema.parse(moneyTransferPushToCard),
  );
}
export function moneyTransferPushToCardFromJSON(
  jsonString: string,
): SafeParseResult<MoneyTransferPushToCard, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => MoneyTransferPushToCard$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'MoneyTransferPushToCard' from JSON`,
  );
}
